import { useContext, useState, useRef } from 'react'
import ProfileContext from '../contexts/ProfileContext'

function EditInfo() {
   const { setIsEditing, profileData, setProfileData } =
      useContext(ProfileContext)
   const [fileData, setFileData] = useState({
      file: null,
   })

   const [imgSrc, setImgSrc] = useState({
      src: profileData.profile_pic_src,
   })
   const [errormsg, setErrorMsg] = useState({
      msg: '',
   })
   const switchToShow = () => {
      setIsEditing(false)
   }

   const updateDescription = (e) => {
      const text = e.target.value
      setProfileData({ ...profileData, ['description']: text })
      //console.log(text)
   }

   const updateName = (e) => {
      const text = e.target.value
      setProfileData({ ...profileData, ['name']: text })
      //console.log(text)
   }

   const updateYear = (id) => {
      var tag = document.getElementsByClassName(id)[0].innerHTML

      if (tag == 'X') tag = ''

      setProfileData({
         ...profileData,
         ['tags']: { status: tag, major: profileData.tags.major },
      })
      //console.log(tag)
   }

   const updateMajor = (e) => {
      const text = e.target.value
      setProfileData({
         ...profileData,
         ['tags']: { status: profileData.tags.status, major: text },
      })
      //console.log(text)
   }
   const hideFileInput = useRef(null)

   const handleClick = (e) => {
      hideFileInput.current.click()
   }

   const validFileType = ['jpeg', 'jpg', 'png']

   const [isValidFile, setIsValidFile] = useState(true)

   const [avatarAlt, setAvatarAlt] = useState({
      alt_tag: 'Avatar',
   })

   const updateProfilePic = async (e) => {
      if (e.target.files && e.target.files[0]) {
         const img = e.target.files[0]
         if (img.type.slice(img.type.indexOf('/') + 1) == 'png') {
            console.log('Image name', img.name)
         }
         setFileData({ ...fileData, ['file']: img })
         console.log(img.type)

         const fileType = img.type.slice(img.type.indexOf('/') + 1)
         console.log(fileType)

         if (validFileType.indexOf(fileType) == -1) {
            console.log('Not a valid File')
            setIsValidFile(false)
            setErrorMsg({
               ...errormsg,
               ['msg']: fileType + ' is not a valid file',
            })
            setAvatarAlt({ ...avatarAlt, ['alt_tag']: fileType })
            console.log(errormsg)
         } else {
            setIsValidFile(true)
            setErrorMsg({ ...errormsg, ['msg']: '' })
            setAvatarAlt({ ...avatarAlt, ['alt_tag']: 'Avatar' })
         }
         const img_src = URL.createObjectURL(img)
         console.log('img_src', img_src)
         setImgSrc({ ...imgSrc, ['src']: img_src })
         //setProfileData({ ...profileData, ['profile_pic_src']: img_src })
         console.log(img_src)
      }
   }
   async function submitFileUpload() {
      //keep the form from actually submitting, since we are handling the action ourselves via
      //the fetch calls to the API
      //e.preventDefault();
      //make the api call to file-uploads
      const formData = new FormData()
      formData.append('uploaderID', sessionStorage.getItem('user'))
      formData.append('attributes', JSON.stringify({ fileType: 'Avatar' }))
      console.log(fileData.file)
      formData.append('file', fileData.file)
      /* for(var pair of formData.entries()) {
         console.log(`${pair[0]}: ${pair[1]}`);
       } */
      const img_upload_obj = await fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/file-uploads',
         {
            method: 'POST',
            headers: {
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: formData,
         }
      )
      const response = await img_upload_obj.json()
      setProfileData({
         ...profileData,
         ['profile_pic_src']: 'https://webdev.cse.buffalo.edu' + response.path,
      })
      return 'https://webdev.cse.buffalo.edu' + response.path
      /* .then(response => response.json())
      .then(result => {
        console.log('Success:', result);
        setProfileData({ ...profileData, ['profile_pic_src']: "https://webdev.cse.buffalo.edu" + result.path })
        
        console.log("The updated url is ", profileData.profile_pic_src)
      })
      .then(submitHandler())
      .catch(error => {
        console.error('Error:', error);
      }); */
   }

   async function submitHandler(path) {
      //keep the form from actually submitting, since we are handling the action ourselves via
      //the fetch calls to the API
      //e.preventDefault();

      //make the api call to the user controller, and update the user fields (username, firstname, lastname)
      const user_obj = await fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users/' +
            sessionStorage.getItem('user'),
         {
            method: 'PATCH',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
               attributes: {
                  // name: profileData.name,
                  // description: profileData.description
                  ...profileData,
                  ['name']: profileData.name,
                  ['description']: profileData.description,
                  ['tags']: profileData.tags,
                  ['username']: profileData.username,
                  ['profile_pic_src']: path,
               },
            }),
         }
      )
      switchToShow(user_obj)

      /* .then(response => response.json())
      .then(result => {
        console.log('Success:', result);
        switchToShow();
      })
      .catch(error => {
        console.error('Error:', error);
      }); */
   }

   const switchandsubmit = async () => {
      const file_upload = await submitFileUpload()
      const userObj = await submitHandler(file_upload)
   }
   return (
      <div className="profile_avatarSection">
         <div className="avatarSection_avatar">
            <img
               src={imgSrc.src}
               alt={avatarAlt.alt_tag}
               className="avatarSection_avatar_image"
            />
            <div className="picture_upload_error_message">{errormsg.msg}</div>
            <div className="picture_upload">
               <button onClick={handleClick} className="picture_upload_button">
                  Upload Picture
               </button>
               <input
                  onChange={updateProfilePic}
                  ref={hideFileInput}
                  style={{ display: 'none' }}
                  type="file"
                  accept="image/png, image/jpeg, image/jpg"
               />
            </div>
         </div>
         <div className="avatarSection_description">
            <div className="avatarSection_description_name">
               <input
                  onChange={updateName}
                  className="input_name"
                  type="text"
                  value={profileData.name}
               />
            </div>
            <div className="avatarSection_description_tags">
               <ul className="avatarSection_tagsList">
                  {profileData.tags.status == 'Freshman' && (
                     <li
                        id="hover_tag"
                        className="tag_freshman chosen_tag"
                        onClick={() => updateYear('tag_freshman')}
                     >
                        Freshman
                     </li>
                  )}
                  {profileData.tags.status != 'Freshman' && (
                     <li
                        id="hover_tag"
                        className="tag_freshman freshman"
                        onClick={() => updateYear('tag_freshman')}
                     >
                        Freshman
                     </li>
                  )}

                  {profileData.tags.status == 'Sophomore' && (
                     <li
                        id="hover_tag"
                        className="tag_sophomore chosen_tag"
                        onClick={() => updateYear('tag_sophomore')}
                     >
                        Sophomore
                     </li>
                  )}
                  {profileData.tags.status != 'Sophomore' && (
                     <li
                        id="hover_tag"
                        className="tag_sophomore sophomore"
                        onClick={() => updateYear('tag_sophomore')}
                     >
                        Sophomore
                     </li>
                  )}

                  {profileData.tags.status == 'Junior' && (
                     <li
                        id="hover_tag"
                        className="tag_junior chosen_tag"
                        onClick={() => updateYear('tag_junior')}
                     >
                        Junior
                     </li>
                  )}
                  {profileData.tags.status != 'Junior' && (
                     <li
                        id="hover_tag"
                        className="tag_junior junior"
                        onClick={() => updateYear('tag_junior')}
                     >
                        Junior
                     </li>
                  )}

                  {profileData.tags.status == 'Senior' && (
                     <li
                        id="hover_tag"
                        className="tag_senior chosen_tag"
                        onClick={() => updateYear('tag_senior')}
                     >
                        Senior
                     </li>
                  )}
                  {profileData.tags.status != 'Senior' && (
                     <li
                        id="hover_tag"
                        className="tag_senior senior"
                        onClick={() => updateYear('tag_senior')}
                     >
                        Senior
                     </li>
                  )}

                  {profileData.tags.status == 'Graduate' && (
                     <li
                        id="hover_tag"
                        className="tag_graduate chosen_tag"
                        onClick={() => updateYear('tag_graduate')}
                     >
                        Graduate
                     </li>
                  )}
                  {profileData.tags.status != 'Graduate' && (
                     <li
                        id="hover_tag"
                        className="tag_graduate graduate"
                        onClick={() => updateYear('tag_graduate')}
                     >
                        Graduate
                     </li>
                  )}

                  {profileData.tags.status == '' && (
                     <li
                        id="hover_tag"
                        className="add_tag chosen_tag"
                        onClick={() => updateYear('add_tag')}
                     >
                        X
                     </li>
                  )}
                  {profileData.tags.status != '' && (
                     <li
                        id="hover_tag"
                        className="add_tag tag"
                        onClick={() => updateYear('add_tag')}
                     >
                        X
                     </li>
                  )}
               </ul>
            </div>
            <div className="majorSection">
               <input
                  type="text"
                  className="input_major"
                  onChange={updateMajor}
                  placeholder="Major"
                  value={profileData.tags.major}
               />
            </div>
            <div className="avatarSection_description_description">
               <textarea
                  className="input_description"
                  name="profile_description"
                  rows="4"
                  cols="50"
                  onChange={updateDescription}
                  value={profileData.description}
               ></textarea>
            </div>
            <div className="avatarSection_description_buttons">
               <div
                  className={`${
                     !isValidFile
                        ? 'avatarSection_description_buttons_button_greyed'
                        : 'avatarSection_description_buttons_button'
                  }`}
                  onClick={() => {
                     if (isValidFile) {
                        switchandsubmit()
                     }
                  }}
               >
                  Submit
               </div>
            </div>
         </div>
      </div>
   )
}
export default EditInfo
